import { render, staticRenderFns } from "./event-post.vue?vue&type=template&id=02502892&scoped=true&"
import script from "./event-post.vue?vue&type=script&lang=js&"
export * from "./event-post.vue?vue&type=script&lang=js&"
import style0 from "./event-post.vue?vue&type=style&index=0&id=02502892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02502892",
  null
  
)

export default component.exports